<template>
<div>
    <div class="columns">
        <div class="column">
            <SearchBox label="N° Pedido" id="sb-1" itemKey="pei_id" itemValue="pei_id" :source="pedidos" :labelFunction="(item) => item.pei_codigo" :searchFunction="buscarPedidos"
                @selectItem="seleccionarPedido">
                <template #default="data">
                    {{ data.item.pei_codigo }}
                </template>
            </SearchBox>
        </div>
        <div class="column">
            <ValidationProvider rules="required" v-slot="{ errors, valid }">
                <b-field label="Tipo de Orden" :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors" custom-class="is-small">
                    <b-select placeholder="Tipo de Orden" v-model="orden.tipo_orden" expanded size="is-small" :disabled="orden.id_orden" @change.native="seleccionarTipoImpuesto(true)">
                        <option value="1">Compra</option>
                        <option value="2">Servicio</option>
                    </b-select>
                </b-field>
            </ValidationProvider>
        </div>
        <div class="column">
            <ValidationProvider rules="required" v-slot="{ errors, valid }">
                <b-field label="Centro de Costo" custom-class="is-small" :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                    <b-autocomplete placeholder="Centro de Costo" icon="magnify" clearable size="is-small" :open-on-focus="true" field="descripcion" :data="centro_costo_filtered"
                        v-model="centro_costo_search" @select="setCentroCosto">
                        <template slot="empty">No results found</template>
                        <template slot-scope="props">
                            {{ props.option.codigo }} {{ props.option.descripcion }}
                        </template>
                    </b-autocomplete>
                </b-field>
            </ValidationProvider>
        </div>
        <div class="column">
            <ValidationProvider rules="required" v-slot="{ errors, valid }">
                <b-field label="Proveedor" custom-class="is-small" :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                    <b-autocomplete placeholder="Proveedor" icon="magnify" clearable size="is-small" v-model="proveedor_search" :data="data.proveedor" @typing="loadProveedores" field="razon_social"
                        @select="setProveedor">
                        <template slot="empty">No results found</template>
                        <template slot-scope="props">
                            {{ props.option.ruc }} {{ props.option.razon_social }}
                        </template>
                    </b-autocomplete>
                </b-field>
            </ValidationProvider>
        </div>
        <div class="column">
            <ValidationProvider rules="required" v-slot="{ errors, valid }">
                <b-field label="Moneda" custom-class="is-small" :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                    <b-select placeholder="Moneda" size="is-small" v-model="orden.moneda.id_moneda" expanded>
                        <option value="1">SOLES</option>
                        <option value="2">DOLARES</option>
                    </b-select>
                </b-field>
            </ValidationProvider>
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <div class="group_condicion_comercial">
                <ValidationProvider rules="required" v-slot="{ errors, valid }">
                    <b-field label="Cóndicion Comercial" custom-class="is-small" :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                        <b-select placeholder="Cóndicion Comercial" size="is-small" v-model="orden.condicion_comercial.id_condicion" expanded @change.native="condicion_comercial_change"
                            class="condicion">
                            <option v-for="item in data.condicion_comercial" :value="item.id_condicion" :key="item.id_condicion">{{ item.descripcion }}</option>
                        </b-select>
                    </b-field>
                </ValidationProvider>
                <div v-if="show_porcentaje">
                    <ValidationProvider rules="required" v-slot="{ errors, valid }">
                        <b-field label="%" custom-class="is-small" :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                            <b-input type="text" size="is-small" v-model="orden.ord_porcentaje_adelanto" placeholder="50.00" class="porcentaje"></b-input>
                        </b-field>
                    </ValidationProvider>
                </div>
            </div>
        </div>
        <div class="column">
            <ValidationProvider rules="required" v-slot="{ errors, valid }">
                <b-field label="Lugar de Entrega" custom-class="is-small" :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                    <b-input v-model="orden.lugar_entrega" size="is-small"></b-input>
                </b-field>
            </ValidationProvider>
        </div>
        <div class="column">
            <ValidationProvider rules="required" v-slot="{ errors, valid }">
                <b-field label="Tipo Comprobante" custom-class="is-small" :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                    <b-select placeholder="Tipo Comprobante" v-model="orden.tipo_documento.id_tipo_documento" expanded size="is-small" @change.native="seleccionarTipoImpuesto(false)">
                        <option v-for="item in data.tipo_documento" :key="item.id_tipo_documento" :value="item.id_tipo_documento">{{ item.descripcion }}</option>
                    </b-select>
                </b-field>
            </ValidationProvider>
        </div>
        <div class="column">
            <b-field label="Numero Documento" custom-class="is-small">
                <b-input type="text" size="is-small" v-model="orden.ord_numero_documento"></b-input>
            </b-field>
        </div>
    </div>
    <div class="columns">
        <div class="column is-3">
            <ValidationProvider rules="required" v-slot="{ errors, valid }">
                <b-field label="Método de Pago" custom-class="is-small" :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                    <b-select v-model="orden.metodo_pago.id_metodo" size="is-small" placeholder="Método de Pago" expanded>
                        <option v-for="item in data.metodo_pago" :key="item.id_metodo" :value="item.id_metodo">{{ item.descripcion }}</option>
                    </b-select>
                </b-field>
            </ValidationProvider>
        </div>
        <div class="column is-3">
            <ValidationProvider rules="required" v-slot="{ errors, valid }">
                <b-field label="Fecha Pago" custom-class="is-small" :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                    <b-datepicker v-model="orden.fecha_pago" :date-formatter="formatDate" size="is-small" placeholder="Fecha de Pago" icon="calendar-today" editable></b-datepicker>
                </b-field>
            </ValidationProvider>
        </div>
        <div class="column" v-if="orden.metodo_pago.id_metodo === 2">
            <ValidationProvider rules="required" v-slot="{ errors, valid }">
                <b-field label="Carta Crédito" custom-class="is-small" :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                    <b-input v-model="orden.carta_credito"></b-input>
                </b-field>
            </ValidationProvider>
        </div>
        <div class="column">
            <div class="field">
                <label class="label is-small">Importación</label>
                <b-checkbox v-model="orden.es_importacion" @change.native="addTaxes">Importación</b-checkbox>
            </div>
        </div>
        <div class="column" v-if="orden.es_importacion">
            <ValidationProvider rules="required" v-slot="{ errors, valid }">
                <b-field label="Pais de Procedencia" custom-class="is-small" :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                    <b-autocomplete placeholder="Pais" icon="magnify" clearable size="is-small" field="nombre" v-model="pais_search" :data="pais_filtered" @select="setPais">
                        <template slot="empty">No results found</template>
                    </b-autocomplete>
                </b-field>
            </ValidationProvider>
        </div>
    </div>
    <div class="columns">
        <div class="column is-3">
            <ValidationProvider rules="required" v-slot="{ errors, valid }">
                <b-field label="Contabilidad" custom-class="is-small" :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                    <b-autocomplete placeholder="Contabilidad" icon="magnify" clearable size="is-small" :open-on-focus="true" v-model="contabilidad_search" :data="data.contabilidad"
                        :custom-formatter="formatUsuario" @select="setContabilidad">
                        <template slot="empty">No results found</template>
                        <template slot-scope="props">
                            {{ props.option.nombre }} {{ props.option.apellido }}
                        </template>
                    </b-autocomplete>
                </b-field>
            </ValidationProvider>
        </div>
        <div class="column is-3">
            <ValidationProvider rules="required" v-slot="{ errors, valid }">
                <b-field label="Administración" custom-class="is-small" :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                    <b-autocomplete placeholder="Administración" icon="magnify" clearable size="is-small" :open-on-focus="true" v-model="administracion_search" :custom-formatter="formatUsuario"
                        :data="data.administracion" @select="setAdministracion">
                        <template slot="empty">No results found</template>
                        <template slot-scope="props">
                            {{ props.option.nombre }} {{ props.option.apellido }}
                        </template>
                    </b-autocomplete>
                </b-field>
            </ValidationProvider>
        </div>
        <div class="column is-3">
            <ValidationProvider rules="required" v-slot="{ errors, valid }">
                <b-field label="Gerencia" custom-class="is-small" :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                    <b-autocomplete placeholder="Gerencia" icon="magnify" size="is-small" clearable :open-on-focus="true" v-model="gerencia_search" :data="data.gerencia"
                        :custom-formatter="formatUsuario" @select="setGerencia">
                        <template slot="empty">No results found</template>
                        <template slot-scope="props">
                            {{ props.option.nombre }} {{ props.option.apellido }}
                        </template>
                    </b-autocomplete>
                </b-field>
            </ValidationProvider>
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <ValidationProvider rules="required" v-slot="{ errors, valid }">
                <b-field label="Referencia" custom-class="is-small" :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                    <b-input v-model="orden.referencia" size="is-small"></b-input>
                </b-field>
            </ValidationProvider>
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <b-field label="Referencia Detalle" custom-class="is-small">
                <b-input type="textarea" rows="2" size="is-small" v-model="orden.referencia_detalle"></b-input>
            </b-field>
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <b-field label="Observación" custom-class="is-small">
                <b-input type="textarea" rows="2" size="is-small" v-model="orden.observacion"></b-input>
            </b-field>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import moment from "moment"
import { ValidationProvider } from "vee-validate"
import { purchaseType, roles } from "../constants/constants"
import { SearchBox } from "../modules/components"
import { PedidoItemsService, ResponseStatus } from "../services"
import OpcionesService from "../services/OpcionesService"
import Toast from "../util/toast"
import { EstadoEnum, Estados, estados, TasasEnum, TipoDocumentoEnum, TipoImpuestoEnum } from "../constants"
import Environment from "../services/Environment"

export default {
    name: "OrdenHeader",
    props: ['orden'],
    components: {
        ValidationProvider,
        SearchBox,
    },
    data() {
        return {
            centro_costo_search: "",
            pais_search: "",
            proveedor_search: "",
            contabilidad_search: "",
            administracion_search: "",
            gerencia_search: "",
            data: {
                centro_costo: [],
                proveedor: [],
                condicion_comercial: [],
                tipo_documento: [],
                metodo_pago: [],
                contabilidad: [],
                gerencia: [],
                administracion: [],
                paises: []
            },
            users: Environment.users,
            pedidos: []
        }
    },
    methods: {
        setCentroCosto(option) {
            this.orden.centro_costo.id_centro_costo = option.id_centro_costo
        },
        setProveedor(option) {
            this.orden.proveedor.id_proveedor = option.id_proveedor
        },
        setAdministracion(option) {
            this.orden.administrador.id_usuario = option.id_usuario
        },
        setGerencia(option) {
            this.orden.gerencia.id_usuario = option.id_usuario
        },
        setContabilidad(option) {
            this.orden.contabilidad.id_usuario = option.id_usuario
        },
        setPais(option) {
            this.orden.pais.id_pais = option.id_pais
        },
        formatUsuario(option) {
            return option.nombre + " " + option.apellido
        },
        loadCentroCosto() {
            OpcionesService
                .getCentrosCosto({
                    centro_costo: {
                        cec_descripcion: "",
                        cec_estado: EstadoEnum.ACTIVO.est_codigo
                    }
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.data.centro_costo = response.data
                    }
                    else {
                        Toast.error(response.message)
                    }
                }).catch(error => {
                    Toast.error(error)

                })
        },
        loadProveedores: _.debounce(function (text) {
            axios.post("/proveedor/get-proveedor", { razon_social: text }).then(
                response => (this.data.proveedor = response.data),
                error => console.error(error)
            )
        }, 250),
        loadCondicionComercial() {
            axios
                .post("/condicion/get-condicion", { descripcion: "" })
                .then(response => (this.data.condicion_comercial = response.data))
        },
        loadMetodoPago() {
            axios
                .post("/metodo-pago/get-metodo", { descripcion: "" })
                .then(response => (this.data.metodo_pago = response.data))
        },
        loadTipoComprobante() {
            axios
                .post("/comprobante/get-comprobante", { descripcion: "" })
                .then(response => (this.data.tipo_documento = response.data))
        },
        loadUsuariosByRol() {
            axios
                .post("/usuario/get-by-rol", { id_role: roles.CONTABILIDAD.id })
                .then(response => {
                    (this.data.contabilidad = response.data)
                    if (!this.orden.id_orden) {
                        this.data.contabilidad.forEach(e => {
                            if (e.id_usuario === this.users.contabilidad) {
                                this.setContabilidad(e)
                                this.contabilidad_search = `${e.nombre} ${e.apellido}`
                            }
                        })
                    }
                })
            axios
                .post("/usuario/get-by-rol", { id_role: roles.GERENCIA.id })
                .then(response => {
                    (this.data.gerencia = response.data)
                    if (!this.orden.id_orden) {
                        this.data.gerencia.forEach(e => {
                            if (e.id_usuario === this.users.gerencia) {
                                this.setGerencia(e)
                                this.gerencia_search = `${e.nombre} ${e.apellido}`
                            }
                        })
                    }
                })
            axios
                .post("/usuario/get-by-rol", { id_role: roles.ADMINISTRADOR.id })
                .then(response => {
                    (this.data.administracion = response.data)
                    if (!this.orden.id_orden) {
                        this.data.administracion.forEach(e => {
                            if (e.id_usuario === this.users.administracion) {
                                this.setAdministracion(e)
                                this.administracion_search = `${e.nombre} ${e.apellido}`
                            }
                        })
                    }
                })
        },
        loadPaises() {
            let _self = this
            axios.get("/pais/list").then(
                res => (_self.data.paises = res.data),
                err => console.error(err)
            )
        },
        formatDate(date) {
            return moment(date).format("YYYY-MM-DD")
        },
        addTaxes() {
            if (parseInt(this.orden.tipo_orden) === purchaseType.COMPRA) {
                if (this.orden.es_importacion) {
                    this.orden.orden_impuestos.push(
                        {
                            id_orden_impuesto: null,
                            descripcion: "Ad. Valorem",
                            valor: 0.11,
                            valor_aplicado: 0,
                        },
                        {
                            id_orden_impuesto: null,
                            descripcion: "Servicio de Aduana",
                            valor: 0.003,
                            valor_aplicado: 0
                        },
                        {
                            id_orden_impuesto: null,
                            descripcion: "Transporte a Almacen EPCM",
                            valor: 0.01,
                            valor_aplicado: 0
                        },
                        {
                            id_orden_impuesto: null,
                            descripcion: "Seguro de Transporte",
                            valor: 0.001,
                            valor_aplicado: 0
                        }
                    )
                } else {
                    this.orden.orden_impuestos.splice(2, 4)
                }
            }
        },
        seleccionarTipoImpuesto(clear_items = true) {
            // seleccionando los impuestos en función al tipo de orden
            if (parseInt(this.orden.tipo_orden) === purchaseType.COMPRA) {
                this.orden.orden_impuestos = [
                    TipoImpuestoEnum.IGV,
                    TipoImpuestoEnum.PERCEPCION,
                ]
            }
            else {
                if (this.orden.tipo_documento.id_tipo_documento === TipoDocumentoEnum.RXH.tid_id) {
                    this.orden.orden_impuestos = [
                        TipoImpuestoEnum.IGV,
                        TipoImpuestoEnum.RETENCION,
                    ]
                }
                else {
                    this.orden.orden_impuestos = [
                        TipoImpuestoEnum.IGV,
                        TipoImpuestoEnum.DETRACCION,
                    ]
                }
            }
            if(clear_items) {
                this.orden.orden_items = []
            }
        },
        condicion_comercial_change() {
            switch (this.orden.condicion_comercial.id_condicion) {
                case 1:
                    this.orden.fecha_pago = new Date()
                    break
                case 2:
                    this.orden.fecha_pago = null
                    break

            }
        },
        buscarPedidos(pei_codigo) {
            PedidoItemsService
                .buscarPedidoParaOC({
                    pedido_items: {
                        pei_codigo
                    }
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.pedidos = response.data
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        seleccionarPedido(pedido) {
            this.$emit("seleccionarPedido", pedido)
        },
    },
    computed: {
        centro_costo_filtered() {
            return this.data.centro_costo.filter(option => {
                return (
                    (option.codigo + " " + option.descripcion)
                        .toString()
                        .toLowerCase()
                        .indexOf(this.centro_costo_search.toLowerCase()) >= 0
                )
            })
        },
        pais_filtered() {
            return this.data.paises.filter(option => {
                return (
                    option.nombre
                        .toString()
                        .toLowerCase()
                        .indexOf(this.pais_search.toLowerCase()) >= 0
                )
            })
        },
        show_porcentaje() {
            return this.orden
                && this.orden.condicion_comercial
                && this.orden.condicion_comercial.id_condicion == 5
        }
    },
    watch: {
        orden: function (val) {
            if (val.id_orden) {
                this.administracion_search = `${this.orden.administrador.nombre} ${this.orden.administrador.apellido}`
                this.gerencia_search = `${this.orden.gerencia.nombre} ${this.orden.gerencia.apellido}`
                this.contabilidad_search = `${this.orden.contabilidad.nombre} ${this.orden.contabilidad.apellido}`
                this.centro_costo_search = this.orden.centro_costo.descripcion
                this.proveedor_search = this.orden.proveedor.razon_social
                if (this.orden.pais) this.pais_search = this.orden.pais.nombre
            }
        }
    },
    mounted() {
        this.loadCentroCosto()
        this.loadCondicionComercial()
        this.loadMetodoPago()
        this.loadTipoComprobante()
        this.loadUsuariosByRol()
        this.loadPaises()
    }
}
</script>

<style scoped>
.group_condicion_comercial {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 4px;
}

.condicion {
    flex: 1 1 auto;
    width: 100%;
}

.porcentaje {
    width: 70px;
    flex: 0 0 auto;
}
</style>
